import script from "./basket.vue?vue&type=script&setup=true&name=basket&lang=js"
export * from "./basket.vue?vue&type=script&setup=true&name=basket&lang=js"

const __exports__ = script;

export default __exports__